import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Ruler, Wind, Feather, Activity, Sparkles, Check } from "lucide-react";
import { useStore } from "@/context/StoreContext";

const CALLOUTS = [
  { key: "callout.fit", icon: Ruler, cls: "c1" },
  { key: "callout.breathable", icon: Wind, cls: "c2" },
  { key: "callout.light", icon: Feather, cls: "c3" },
  { key: "callout.support", icon: Activity, cls: "c4" },
  { key: "callout.comfort", icon: Sparkles, cls: "c5" },
  { key: "callout.wear", icon: Check, cls: "c6" },
];

export default function Feature() {
  const { t, products, addToCart, setCartOpen, scrollToSection } = useStore();
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.25 });

  const pinkKnee = products.find((p) => p.id === "knee-support-pink") ?? {
    id: "knee-support-pink",
    name: "Knee Support",
    color: "Pink",
    price: 5,
    image: "/products/knee-support-pink.png",
    group: "knee",
  };

  const shopNow = () => {
    addToCart(pinkKnee, null);
    setCartOpen(true);
  };

  return (
    <section className="section">
      <div className="container">
        <motion.div
          className="feature-section"
          id="active"
          data-testid="feature-section"
          ref={ref}
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <div className="feature-grid">
            <div className="feature-product">
              {CALLOUTS.map((c, i) => (
                <motion.span
                  key={c.key}
                  className={`callout ${c.cls}`}
                  animate={inView ? { y: [0, -8, 0] } : { y: 0 }}
                  transition={{
                    duration: 3.2 + i * 0.35,
                    repeat: inView ? Infinity : 0,
                    ease: "easeInOut",
                    delay: i * 0.25,
                  }}
                >
                  <c.icon size={13} /> {t(c.key)}
                </motion.span>
              ))}
              <motion.img
                className="feature-product-img"
                src={pinkKnee.image}
                alt="Pink PaMak knee support"
                animate={{ rotate: inView ? 360 : 0 }}
                transition={{ duration: 30, repeat: inView ? Infinity : 0, ease: "linear" }}
              />
            </div>

            <div className="feature-copy">
              <p className="section-title-small">{t("feature.eyebrow")}</p>
              <h2>
                {t("feature.title1")}
                <br />
                {t("feature.title2").split("*").map((part, i) => (i % 2 ? <span key={i}>{part}</span> : part))}
                <br />
                {t("feature.title3").split("*").map((part, i) => (i % 2 ? <span key={i}>{part}</span> : part))}
              </h2>
              <p className="muted">{t("feature.desc")}</p>
              <div className="hero-buttons">
                <button className="btn btn-dark" data-testid="feature-shop-now-button" onClick={shopNow}>
                  {t("feature.shop")} →
                </button>
                <button className="btn btn-light" data-testid="feature-learn-more-button" onClick={() => scrollToSection("story")}>
                  {t("feature.learn")} →
                </button>
              </div>
            </div>

            <div className="feature-lifestyle" />
          </div>
        </motion.div>
      </div>
    </section>
  );
}
